import { Injectable } from '@angular/core';
import { environment } from 'src/environments/enviroments';
import { RequestBodyMinute } from '../sub-page/minutes/interface/minute-detail';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CompanyLinesDTO } from '../interface/company-client.interface';
import { RegisterMinuteWithOperationRequest } from '../interface/company-minutes.interface';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';

@Injectable({
  providedIn: 'root'
})
export class RegisterMinutesService {

  constructor(private http: HttpClient) {}
  
  resgiterMinute(value: RequestBodyMinute){
    console.log(value)
    const endpoint = `${environment.apiUrl}/Minutes`;
    return this.http.post<any>(endpoint,value);
  }

  getCompanyLines(companyId: number): Observable<CompanyLinesDTO> {
    const endpoint = `${environment.apiUrl}/Company/${companyId}/lines`;
    return this.http.get<CompanyLinesDTO>(endpoint);
  }

  registerMinuteWithOperations(request: RegisterMinuteWithOperationRequest): Observable<ActionResponseDTO<number | null>>{
    const endpoint = `${environment.apiUrl}/Minutes/withOps`;
    return this.http.post<ActionResponseDTO<number | null>>(endpoint, request);
  }

}
